export function extractToken(payload) {
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  return (
    payload.access_token ||
    payload.token ||
    payload.jwt ||
    (payload.data && (payload.data.access_token || payload.data.token || payload.data.jwt)) ||
    null
  );
}

export function extractRefreshToken(payload) {
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  return (
    payload.refresh_token ||
    payload.refreshToken ||
    (payload.data && (payload.data.refresh_token || payload.data.refreshToken)) ||
    null
  );
}

export function extractUser(payload) {
  if (!payload || typeof payload !== 'object') {
    return null;
  }

  const mergePermissions = (user, source) => {
    if (!user || typeof user !== 'object') {
      return user;
    }

    return {
      ...user,
      ...(Array.isArray(source?.permissions) ? { permissions: source.permissions } : {}),
      ...(source?.tenantRestrictedMode !== undefined
        ? { tenantRestrictedMode: Boolean(source.tenantRestrictedMode) }
        : {}),
    };
  };

  if (payload.profile) {
    return mergePermissions(payload.profile, payload);
  }

  if (payload.user) {
    return mergePermissions(payload.user, payload);
  }

  if (payload.data?.profile) {
    return mergePermissions(payload.data.profile, payload.data);
  }

  if (payload.data?.user) {
    return mergePermissions(payload.data.user, payload.data);
  }

  return payload.data || payload;
}

export function normalizeList(payload) {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (!payload || typeof payload !== 'object') {
    return [];
  }

  if (Array.isArray(payload.items)) {
    return payload.items;
  }

  if (Array.isArray(payload.profiles)) {
    return payload.profiles;
  }

  if (Array.isArray(payload.accounts)) {
    return payload.accounts;
  }

  if (Array.isArray(payload.data)) {
    return payload.data;
  }

  if (payload.data && Array.isArray(payload.data.items)) {
    return payload.data.items;
  }

  return [];
}
